<script setup>
import SubNav from "../../components/global/SubNav.vue";
import {ref} from "vue";

const links = ref([
    { to: '/orders/pending', label: 'Pending'},
    { to: '/orders/complete', label: 'Completed'},
    { to: '/orders/stats', label: 'Stats'},
]);

</script>

<template>
    <sub-nav :links="links" />
    <router-view v-slot="{ Component }">
        <keep-alive :include="['OrdersPendingView', 'OrdersCompleteView']">
            <component :is="Component" />
        </keep-alive>
    </router-view>
</template>
